<script lang="ts">
    import { beforeUpdate, onMount } from "svelte";

    export let row;
    export let col;

    $: formatedValue = () => {
        switch (col.key) {
            case "creativeId":
            case "locationName":
            case "stationId":
            case "playouts":
            case "releaseStatus":
            case "name":
                return col.value(row);
            case "impressions":
                return Math.floor(col.value(row));
            case "turnover":
                return (
                    Math.round((col.value(row) + Number.EPSILON) * 100) / 100 +
                    " €"
                );
            default:
                break;
        }
    };
</script>

<div>
    <span>{formatedValue()}</span>
</div>

<style>
    div {
        display: flex;
        justify-content: center;
        flex-flow: column;
        height: 100%;
        text-align: center;
        vertical-align: middle;
    }
    span {
        text-overflow: ellipsis;
        overflow: hidden;
        padding: 1.5rem;
    }
</style>
